import { apiClient } from "./useApi"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const patientEndpoints = (build: McoEndpointBuilder) => ({
	patientFilters: build.query({
		queryFn: (_: void) => apiClient.patient.getFilters(),
		providesTags: [ApiTag.Tenant] // Not adding Patient tag as don't want to constantly be refetching when little will change as request is expensive
	}),
	patientSearch: build.query({
		queryFn: apiClient.patient.search,
		providesTags: [ApiTag.Tenant] // Not adding Patient tag as don't want to constantly be refetching when little will change as request is expensive
	})
})

export default patientEndpoints
